import { Component, computed, inject, Input, ChangeDetectionStrategy } from '@angular/core';
import { PrefixSubscriptionPipe, TranslatePipe } from '../../../../utils/pipes';
import { AuthService } from '../../../services/auth.service';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-top',
    imports: [TranslatePipe, PrefixSubscriptionPipe, RouterModule],
    templateUrl: './top.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './top.component.scss'
})
export class TopComponent {
    @Input() fullWidth = false;
    @Input() boxedWidth = false;

    user = inject(AuthService).user;
    isTrial = computed(() => {
        if (this.user()?.subscriptionId) {
            const sub = this.user().subscriptions.find((x) => x.id === this.user()?.subscriptionId);
            // @todo trail fallback
            if (sub.status === 'trial' || (sub.status as any) === 'trail') {
                return true;
            }
        }
        return false;
    });
}
